import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const DashboardContainer = styled.div`
  max-width: 1100px;
  margin: 40px auto;
  padding: 20px;
  font-family: 'Inter', 'Segoe UI', sans-serif;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 50px;

  h1 {
    font-size: 2.5rem;
    color: #1e293b;
    margin-bottom: 10px;
    font-weight: 800;
    letter-spacing: -1px;
  }

  p {
    color: #64748b;
    font-size: 1.1rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 25px;
  padding: 10px;
`;

const Card = styled(Link)`
  background: white;
  padding: 35px 25px;
  border-radius: 24px;
  text-decoration: none;
  color: #1e293b;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #f1f5f9;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0) 100%);
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0,0,0,0.1);
    border-color: #2563eb;
    
    &::before {
      opacity: 1;
    }

    .icon-wrapper {
      transform: scale(1.1) rotate(5deg);
      background: #eff6ff;
    }
  }

  h3 {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: #64748b;
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;

const IconWrapper = styled.div`
  font-size: 3.5rem;
  width: 100px;
  height: 100px;
  background: #f8fafc;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
`;

function Home() {
  const menuItems = [

    {
      title: 'Gestión de Docentes',
      description: 'Administrar el personal docente, sus datos básicos y especialidades.',
      icon: '👨‍🏫',
      path: '/docentes',
      color: '#4f46e5'
    },
    {
      title: 'Subir y Validar',
      description: 'Carga archivos .dat del biométrico y valida asistencias mensuales.',
      icon: '📁',
      path: '/subir-validar',
      color: '#2563eb'
    },
    {
      title: 'Configurar Periodos',
      description: 'Definir los turnos, horas de entrada, salida y márgenes de tolerancia.',
      icon: '🕒',
      path: '/periodos',
      color: '#7c3aed'
    },
    {
      title: 'Asignar Horarios',
      description: 'Asignar periodos específicos y días de trabajo a cada docente.',
      icon: '📝',
      path: '/horarios',
      color: '#db2777'
    }
  ];

  return (
    <DashboardContainer>
      <Header>
        <h3>Panel de Control</h3>
        <p>Bienvenido al Sistema de Gestión Biométrica y Control de Asistencia . Seleccione una opción para comenzar.</p>
      </Header>

      <Grid>
        {menuItems.map((item, index) => (
          <Card key={index} to={item.path}>
            <IconWrapper className="icon-wrapper">
              {item.icon}
            </IconWrapper>
            <div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </Card>
        ))}
      </Grid>
    </DashboardContainer>
  );
}

export default Home;
